import {useMutation} from '@apollo/react-hooks';

import type {
    CreateRole as CreateRoleMutation,
    CreateRoleVariables as CreateRoleMutationVariables,
    RoleCreateInput,
} from 'nutshell-graphql-types';

import CREATE_ROLE from '../mutations/create-role.graphql';
import GET_ROLES from '../queries/get-roles.graphql';

export function useCreateRole(): {
    createRole: (arg1: RoleCreateInput) => Promise<any>;
    isCreating: boolean;
} {
    const [createRole, {loading}] = useMutation<CreateRoleMutation, CreateRoleMutationVariables>(
        CREATE_ROLE
    );

    return {
        createRole: (input: RoleCreateInput) =>
            createRole({
                variables: {input},
                optimisticResponse: {
                    // @ts-expect-error
                    __typename: 'RoleCreatePayload',
                    roleCreate: {
                        __typename: 'RoleCreatePayload',
                        role: {
                            __typename: 'Role',
                            id: 'temp',
                            isImmutable: false,
                            name: input.name,
                            permissions: [],
                            position: 1000, // doesn't matter just needs to be big numby
                            usersCount: 0,
                            isDefault: false,
                        },
                    },
                },
                update: (proxy, mutationResults) => {
                    const newRole =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.roleCreate &&
                        mutationResults.data.roleCreate.role;

                    const cacheResult = proxy.readQuery({
                        query: GET_ROLES,
                    });

                    if (cacheResult && mutationResults.data) {
                        proxy.writeQuery({
                            query: GET_ROLES,
                            data: {
                                // @ts-expect-error
                                roles: [...cacheResult.roles, newRole],
                            },
                        });
                    }
                },
            }),
        isCreating: loading,
    };
}
